import { useMutation, useQueryClient } from '@tanstack/react-query';
import { estimateConvertBoqService } from '../services/estimateConvertBoq.service';

export function useConvertEstimateToBoq(estimateId?: string) {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: () => estimateConvertBoqService.convertToBoq(estimateId!),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['estimates'] });
      queryClient.invalidateQueries({ queryKey: ['construction-boqs'] });
    },
  });

  return {
    convertToBoq: mutation.mutateAsync,
    isConverting: mutation.isPending,
    error: mutation.error as Error | null,
  };
}
